import React from 'react';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { UserIcon, SignOutIcon } from '../common/Icons';

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <Navbar bg="white" expand="lg" className="border-bottom">
      <Container fluid>
        <Button 
          variant="outline-secondary" 
          className="d-lg-none me-3" 
          onClick={onToggleSidebar}
        >
          <span className="navbar-toggler-icon">☰</span>
        </Button>
        <Navbar.Brand href="#">
          Gestion Commerciale
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavDropdown 
              title={
                <span>
                  <UserIcon className="me-2" />
                  {user?.name}
                </span>
              } 
              id="user-dropdown"
            >
              <NavDropdown.Item href="#profile">
                <UserIcon className="me-2" />
                Profil
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                <SignOutIcon className="me-2" />
                Déconnexion
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;